module.exports = __webpack_public_path__ + "media/images/ln/num_5-c055c06c625a2925e55e6805654f9f95.png";